import type { TableColumn, TableField } from "../../composables/Query/collectionContext";

export function isTableColumn(field: TableField): field is TableColumn {
  return typeof field === "object" && field !== null;
}

export function tableColumnCount(
  tableFields: Partial<Record<string, TableField>> | undefined,
  options: { selectable?: boolean, hasRightSlot?: boolean } = {},
): number {
  return (options.selectable ? 1 : 0)
    + Object.keys(tableFields ?? {}).length
    + (options.hasRightSlot ? 1 : 0);
}

export function columnWidthStyle(field: TableField): { width: string } | undefined {
  if (!isTableColumn(field) || !field.width || field.width === "auto") {
    return undefined;
  }

  return {
    width: typeof field.width === "number" ? `${field.width}px` : field.width,
  };
}
